import type { ToastrType, ToastService } from "./types"

let toastHandler: ToastService | null = null

export function registerToastService(service: ToastService) {
    toastHandler = service
}

export const toastr: ToastrType = {
    success: (msg, time) => toastHandler?.show(msg, 'success', time),
    error: (msg, time) => toastHandler?.show(msg, 'error', time),
    info: (msg, time) => toastHandler?.show(msg, 'info', time),
    warning: (msg, time) => toastHandler?.show(msg, 'warning', time),
}